import { ReactNode, useRef, useState } from "react";

import { Tree } from "components/objectTree/types";
import { ModelTreeNodeData } from "features/modelTree/types";
import { emptyModelTree } from "features/modelTree/utils";

import { PreloadedTreeContext, PreloadedTreeRootReadyContext, SetTreeContext, TreeContext } from "./context";
import { useObjectTreePreload } from "./useObjectTreePreload";

export function ObjectTreeProvider({ children }: { children: ReactNode }) {
    const [tree, setTree] = useState<Tree<ModelTreeNodeData>>(emptyModelTree);

    const preloadedTreeRef = useRef<Tree<ModelTreeNodeData> | null>(null);
    const [preloadedRootReady, setPreloadedRootReady] = useState(false);
    useObjectTreePreload(preloadedTreeRef, setPreloadedRootReady);

    return (
        <PreloadedTreeContext.Provider value={preloadedTreeRef}>
            <PreloadedTreeRootReadyContext.Provider value={preloadedRootReady}>
                <TreeContext.Provider value={tree}>
                    <SetTreeContext.Provider value={setTree}>{children}</SetTreeContext.Provider>
                </TreeContext.Provider>
            </PreloadedTreeRootReadyContext.Provider>
        </PreloadedTreeContext.Provider>
    );
}
